import axios from 'axios'
import ValidationService from 'services/ValidationService'
import AuthService from 'services/AuthService'
import i18n from './i18n/index'
import Router from '~/router'

function createResponse({ data, headers, status }) {
    let contentType = headers['content-type'] || ''
    const response =
        (contentType.indexOf('application/json') !== -1 || contentType.indexOf('application/pdf') !== -1) &&
        typeof data === 'object'
            ? data
            : {}

    response._headers = headers
    response._status = status

    return response
}

function createErrorObject(error) {
    function ErrorObject() {
        this.field = error.field
        this.message = i18n.global.t(`validations.${error.message}`)
    }

    ErrorObject.prototype.toString = function () {
        return this.message
    }

    return new ErrorObject()
}

function extractErrors({ error: { invalidFields: errors } }) {
    return errors.reduce((messages, error) => {
        messages[error.field] = createErrorObject(error)
        return messages
    }, {})
}

axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.interceptors.request.use((config) => {
    if (AuthService.isLoggedIn()) {
        config.headers['Authorization'] = AuthService.getToken()
    }
    config.headers['x-bookeraj-key'] = process.env.VUE_APP_BOOKERAJ_KEY

    return config
})

axios.interceptors.response.use(
    (response) => createResponse(response),
    async (error) => {
        error.response = createResponse(error.response)
        const responseStatus = error.response._status
        let response

        if (responseStatus === 401) {
            response = await handleUnauthorizedError(axios, error.config)
        } else if (responseStatus === 403) {
            handleForbiddenError()
        } else if (responseStatus === 422) {
            response = handleValidationEror(error.response)
        }

        return response || Promise.reject(error.response)
    },
)

const handleUnauthorizedError = async (axios, config) => {
    const dontRetryUrls = ['/auth/refresh']
    if (!config._retry && !dontRetryUrls.includes(config.url)) {
        config._retry = true
        try {
            const token = await AuthService.refreshToken()
            config.headers['Authorization'] = `Bearer ${token}`
            return axios(config)
        } catch (error) {
            Router.push('login')
        }
    }
}

const handleForbiddenError = async () => {
    Router.push('/errors/no-access')
}

const handleValidationEror = (error) => {
    if (error.error.invalidFields.length) {
        ValidationService.set(extractErrors(error))
    }
}

export default axios
